<template>
    <div class="content">
        <h2 class="content_title">Today's Goal</h2>
        <div class="plan_wrap">
            <div class="planhead clearfix">
                <div class="plan_title float_left clearfix">
                    <img :src="'../assets/images/goal_txt.png'" alt="Today's Goal" class="pcgoalimg float_left">
                    <p class="float_left">이번 시간의 <strong class="bold">학습 내용</strong>과<span><strong class="bold">학습 목표</strong>를 확인해보세요.</span></p>
                </div>
                <div class="plan_img">
                    <img :src="'../assets/images/planimg.png'" alt="">
                </div>
            </div>
            <div class="plan_cont_wrap clearfix">
                <div class="plan_cont float_left">
                    <h3 class="title"><span class="plandot1"></span>학습 내용</h3>
                    <ul>
                        <li v-for="body1 in currentSlide.body1">
                            {{body1}}
                        </li>
                    </ul>
                </div>
                <div class="plan_cont float_right">
                    <h3 class="title"><span class="plandot2"></span>학습 목표</h3>
                    <ul>
                        <li v-for="body2 in currentSlide.body2">
                            {{body2}}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <audio v-if="currentSlide.bgm != undefined" ref="currentAudio">
            <source :src="'../assets/media/' + currentSlide.bgm" type="audio/mpeg">
        </audio>
    </div>
</template>
<script>
export default {
    props: ['currentSlide'],
    data(){
        return{
            list : []
        }
    },
    methods:{
        getList(){
        }
    },
    mounted(){
        setTimeout(()=>{
            this.$refs.currentAudio.play()
        }, 1000);
    }
}
</script>